import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "info-row" }
const _hoisted_2 = { class: "value" }
const _hoisted_3 = { class: "info-row" }
const _hoisted_4 = { class: "value" }
const _hoisted_5 = { class: "info-row" }
const _hoisted_6 = { class: "value" }
const _hoisted_7 = { class: "info-row" }
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "input-suffix" }
const _hoisted_10 = { class: "dialog-footer" }

import { ref, watch, reactive, computed } from 'vue';
import { ElMessage, type FormInstance, type FormRules } from 'element-plus';
import { useApi } from '@/hooks/useApi';


export default /*@__PURE__*/_defineComponent({
  __name: 'resolve',
  props: {
    modelValue: { type: Boolean },
    orderData: {}
  },
  emits: ["update:modelValue", "success"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const visible = ref(false);
const formRef = ref<FormInstance>();
const submitting = ref(false);

// 表单数据
const formData = reactive({
  backPrice: 0,
  postcode: '',
  processResult: '',
});

// 表单验证规则
const rules = computed((): FormRules => ({
  backPrice: [
    {
      validator: (rule: any, value: number, callback: any) => {
        if (value === undefined || value === null) {
          callback(new Error('请输入退款金额'));
        } else if (value < 0) {
          callback(new Error('退款金额不能为负数'));
        } else if (value > parseFloat(props.orderData.realPrice || props.orderData.totalPrice || '0')) {
          callback(new Error('退款金额不能超过实际价格'));
        } else {
          callback();
        }
      },
      trigger: 'blur',
    },
  ],
  processResult: [
    { required: true, message: '请输入处理结果', trigger: 'blur' },
    { min: 10, max: 500, message: '处理结果长度应在10-500个字符之间', trigger: 'blur' },
  ],
}));

// 重置表单
const resetForm = () => {
  formData.backPrice = parseFloat(props.orderData.backPrice || '0');
  formData.postcode = props.orderData.postcode || '';
  formData.processResult = '';
  formRef.value?.clearValidate();
};

// 监听props变化
watch(() => props.modelValue, (newVal) => {
  visible.value = newVal;
  if (newVal) {
    // 重置表单
    resetForm();
  }
}, { immediate: true });

// 监听visible变化
watch(visible, (newVal) => {
  emit('update:modelValue', newVal);
});

// 关闭弹窗
const handleClose = () => {
  visible.value = false;
};

// 提交处理
const handleSubmit = async() => {
  if (!formRef.value) {
    return;
  }

  try {
    const valid = await formRef.value.validate();
    if (!valid) {
      return;
    }

    submitting.value = true;

    await useApi().billApi.processAfterSalesbill({
      billId: props.orderData.id,
      processResult: formData.processResult,
      backPrice: String(formData.backPrice),
      postcode: formData.postcode,
    });

    ElMessage.success('售后处理成功');
    emit('success');
    handleClose();
  } catch (error) {
    ElMessage.error('售后处理失败，请重试');
    console.error('售后处理失败:', error);
  } finally {
    submitting.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((visible).value = $event)),
    title: "处理售后",
    width: "600px",
    "before-close": handleClose,
    "close-on-click-modal": false
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_el_button, { onClick: handleClose }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSubmit,
          loading: submitting.value
        }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [
            _createTextVNode(" 确认处理 ")
          ])),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: formData,
        rules: rules.value,
        "label-width": "100px",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_card, {
            class: "order-info",
            shadow: "never"
          }, {
            header: _withCtx(() => _cache[5] || (_cache[5] = [
              _createElementVNode("span", null, "订单信息", -1)
            ])),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "label" }, "订单编号：", -1)),
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.orderData.id || '无'), 1)
              ]),
              _createElementVNode("div", _hoisted_3, [
                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "label" }, "订单名称：", -1)),
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.orderData.name || '无'), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "label" }, "实际价格：", -1)),
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.orderData.realPrice || _ctx.orderData.totalPrice || '0') + "元", 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "label" }, "售后原因：", -1)),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.orderData.reason || '无'), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "总计退款金额",
            prop: "backPrice",
            class: "form-item"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input_number, {
                modelValue: formData.backPrice,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.backPrice) = $event)),
                min: 0,
                max: parseFloat(_ctx.orderData.realPrice || _ctx.orderData.totalPrice || '0'),
                precision: 2,
                "controls-position": "right",
                style: {"width":"200px"}
              }, null, 8, ["modelValue", "max"]),
              _createElementVNode("span", _hoisted_9, "元（最大可退：" + _toDisplayString(_ctx.orderData.realPrice || _ctx.orderData.totalPrice || '0') + "元）", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "运单号",
            prop: "postcode",
            class: "form-item"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.postcode,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.postcode) = $event)),
                placeholder: "请输入运单号",
                clearable: "",
                maxlength: "50",
                "show-word-limit": ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "处理结果",
            prop: "processResult",
            class: "form-item"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.processResult,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.processResult) = $event)),
                type: "textarea",
                rows: 4,
                placeholder: "请详细说明处理结果和原因",
                maxlength: "500",
                "show-word-limit": ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})